import { render, staticRenderFns } from "./TableDropdown.vue?vue&type=template&id=56930af4"
import script from "./TableDropdown.vue?vue&type=script&lang=ts"
export * from "./TableDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports